import { initReactI18next } from 'react-i18next'

import * as i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import { Languages } from '@/enums/languages'

import translationCS from './public/locales/cs/translation.json'
import translationEN from './public/locales/en/translation.json'
//import translationEN from './public/locales/en/empty-template.json'
import translationES from './public/locales/es/translation.json'
import translationFI from './public/locales/fi/translation.json'
import translationHR from './public/locales/hr/translation.json'
import translationNL from './public/locales/nl/translation.json'
import translationNO from './public/locales/no/translation.json'
import translationPL from './public/locales/pl/translation.json'
import translationRO from './public/locales/ro/translation.json'
import translationSV from './public/locales/sv/translation.json'

const resources: i18n.Resource = {
  [Languages.CS]: {
    translation: translationCS,
  },
  [Languages.EN]: {
    translation: translationEN,
  },
  [Languages.ES]: {
    translation: translationES,
  },
  [Languages.PL]: {
    translation: translationPL,
  },
  [Languages.RO]: {
    translation: translationRO,
  },
  [Languages.FI]: {
    translation: translationFI,
  },
  [Languages.HR]: {
    translation: translationHR,
  },
  [Languages.SV]: {
    translation: translationSV,
  },
  [Languages.NO]: {
    translation: translationNO,
  },
  [Languages.NL]: {
    translation: translationNL,
  },
}

const availableLanguages = window.config.AVAILABLE_LOCALES
const providedLanguages = Object.keys(resources)
if (providedLanguages && availableLanguages && availableLanguages.length > 0) {
  providedLanguages.forEach((lng: string): void => {
    if (!availableLanguages.includes(lng)) {
      delete resources[lng]
    }
  })
}

const options = {
  order: ['navigator'],
}
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources,
    // lng: Languages.ES, // <--- turn off for detection to work
    load: 'languageOnly',
    debug: true,
    fallbackLng: window.config.DEFAULT_LOCALE,
    detection: options,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
